import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home'
import Business from '@/pages/Business'
import AboutUs from '@/pages/AboutUs'
import Intro from '@/pages/about/Intro'
import Contact from '@/pages/about/Contact'
import Hire from '@/pages/about/Hire'
import News from '@/pages/about/News'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: 'home'
    },
    {
      path: '/home',
      name: 'Home',
      component: Home
    },
    {
      path: '/business',
      name: 'Business',
      component: Business
    },
    {
      path: '/aboutUs',
      name: 'AboutUs',
      component: AboutUs,
      children: [
        {
          path: 'intro',
          name: 'intro',
          component: Intro
        },
        {
          path: 'contact',
          name: 'contact',
          component: Contact
        },
        {
          path: 'hire',
          name: 'hire',
          component: Hire
        },
        {
          path: 'news',
          name: 'news',
          component: News
        },
        {
          path: '',
          redirect: 'intro'
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js